import Nav from "./components/nav/Nav";
import UserInfo from "./components/UserInfo";
import Content from "./components/Content";
function App() {
  return (
    <div className="App">
      <Nav />
      <UserInfo />
      <Content />
    </div>
  );
}

export default App;
